// API Types
export interface FlashcardSuggestion {
  front: string;
  back: string;
}

export interface AIChatRequest {
  message: string;
  topicGuid: string;
  topicTitle: string;
}

export interface AIChatResponse {
  messageId: string;
  content: string;
  timestamp: string;
  topicGuid: string;
  topicTitle: string;
  tokenCount?: number;
  cost?: number;
  isFallbackResponse?: boolean;
  sender: 'ai' | 'user';
  suggestedFlashcard?: FlashcardSuggestion;
}

export interface AIChatMessage {
  id: string;
  content: string;
  sender: 'user' | 'ai';
  timestamp: Date;
  isLoading?: boolean;
  isStreaming?: boolean;
  tokenCount?: number;
  cost?: number;
  isFallbackResponse?: boolean;
  suggestedFlashcard?: FlashcardSuggestion;
}

export type AIChatStatus = 'idle' | 'loading' | 'streaming' | 'error' | 'rateLimited';

export type AIChatErrorCode = 'http' | 'network' | 'unknown';

export interface AIChatError {
  code: AIChatErrorCode;
  message: string;
  status?: number;
}

export interface AIChatState {
  messages: AIChatMessage[];
  status: AIChatStatus;
  error: AIChatError | null;
  topicGuid: string | null;
  topicTitle: string | null;
  dailyRemaining: number | null;
  dailyLimit: number | null;
  resetsAt: string | null;
}

// Helper function to convert API response to frontend message format
export const convertApiResponseToMessage = (response: AIChatResponse): AIChatMessage => {
  return {
    id: response.messageId,
    content: response.content,
    sender: response.sender,
    timestamp: new Date(response.timestamp),
    tokenCount: response.tokenCount,
    cost: response.cost,
    isFallbackResponse: response.isFallbackResponse,
    suggestedFlashcard: response.suggestedFlashcard
  };
};

// Helper function to create user message
export const createUserMessage = (content: string): AIChatMessage => {
  return {
    id: Date.now().toString(),
    content,
    sender: 'user',
    timestamp: new Date()
  };
};
